import React from 'react';
import ResponsiveImage from '../../responsive-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Hero = ({
  images,
  currentImage,
  hasBackground
}) => {
  if (hasBackground) {
    return /*#__PURE__*/_jsxs("div", {
      className: style.imageWrapper,
      children: [images.map(image => /*#__PURE__*/_jsx(ResponsiveImage, {
        className: style.mobileImage,
        desktopImageUrl: image,
        mobileImageUrl: image,
        mobileRatio: "standard",
        desktopRatio: "standard",
        numberOfItems: 2,
        alt: ""
      }, image)), /*#__PURE__*/_jsx(ResponsiveImage, {
        className: style.imageOnBackground,
        desktopImageUrl: currentImage,
        mobileImageUrl: currentImage,
        mobileRatio: "standard",
        desktopRatio: "standard",
        numberOfItems: 2,
        alt: ""
      })]
    });
  } else {
    return /*#__PURE__*/_jsx(ResponsiveImage, {
      className: style.imageWithoutBackground,
      desktopImageUrl: currentImage,
      mobileImageUrl: currentImage,
      mobileRatio: "standard",
      desktopRatio: "standard",
      numberOfItems: 2,
      alt: ""
    });
  }
};

Hero.defaultProps = {
  hasBackground: false
};
export default Hero;